import api from '../axiosInstance';

export const getPjudIntegrationByUserId = async (userId) => {
  if (!userId) {
    throw new Error('userId requerido para consultar la integración PJUD.');
  }
  const response = await api.get(`/Integration/PjudIntegration/user/${userId}`);
  return response.data;
};

export const createPjudIntegration = async (payload) => {
  const response = await api.post('/Integration/PjudIntegration', payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

export const deactivatePjudIntegrationByUserId = async (userId) => {
  if (!userId) {
    throw new Error('userId requerido para desvincular la integración PJUD.');
  }
  const response = await api.put(
    `/Integration/PjudIntegration/user/${userId}`,
    { active: false, userId },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};
